import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import FarmsTab from '@/views/FarmsTab.vue'
import BatchesTab from '@/views/BatchesTab.vue'
import ShipmentsTab from '@/views/ShipmentsTab.vue'
import LotsTab from '@/views/LotsTab.vue'
import Sidebar from '@/views/Sidebar.vue'
import { requireAuth } from '@/services/AuthService'
import { checkTabAccess } from '@/utils/permissions'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: requireAuth,
      children: [
        {
          name: 'farms',
          path: 'farms',
          components: {
            tab: FarmsTab,
            sidebar: Sidebar
          },
          beforeEnter: checkTabAccess,
          props: { sidebar: { type: 'FARM' } },
          children: [{
            name: 'farms.edit',
            path: ':id',
            components: {
              tab: FarmsTab,
              sidebar: Sidebar
            },
            props: { sidebar: { type: 'FARM' } }
          }]
        },
        {
          name: 'shipments',
          path: 'shipments',
          components: {
            tab: ShipmentsTab,
            sidebar: Sidebar
          },
          beforeEnter: checkTabAccess,
          props: { sidebar: { type: 'SHIPMENT' } },
          children: [{
            name: 'shipments.edit',
            path: ':id',
            components: {
              tab: ShipmentsTab,
              sidebar: Sidebar
            },
            props: { sidebar: { type: 'SHIPMENT' } }
          }]
        },
        {
          name: 'lots',
          path: 'lots',
          components: {
            tab: LotsTab,
            sidebar: Sidebar
          },
          beforeEnter: checkTabAccess,
          props: { sidebar: { type: 'LOT' } },
          children: [{
            name: 'lots.edit',
            path: ':id',
            components: {
              tab: LotsTab,
              sidebar: Sidebar
            },
            props: { sidebar: { type: 'LOT' } }
          }]
        },
        {
          name: 'batches',
          path: 'batches',
          components: {
            tab: BatchesTab,
            sidebar: Sidebar
          },
          beforeEnter: checkTabAccess,
          props: { sidebar: { type: 'BATCH' } }
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue')
    }
  ],
  mode: 'history'
})
